import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { UserSettings } from './usersettings';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
var moment = require('moment');

@Component({
    selector: 'vend-template',
    template: require('./vendorTemplate.html'),
    styles: [``]
})
export class vendorList implements OnInit {
    @Input("cValue") cValue: any;
    @Input("dValue") dvalue: any;
    @Input('DisableClose') DisableClose: any;
    @Input('vendorList1') vendorList1: any;
    @Input('filterType') filterType: any;
    @Input('SerachValue') SerachValue: any;
    @Input('LastSelectedId') LastSelectedId: any;
    @ViewChild('vendoroutstanding') vendoroutstanding: ElementRef;
    @Output() SelectedVendor = new EventEmitter();
    static parameters = [UtilityService, HotkeysService, HttpClient, NgbModal]
    public overlayLoadingTemplate: any;
    public SelectedRowIndex = 0;

    gridApiVen: any;
    paginationConf: any;
    gridColumnApiCust: any;
    vendorList: any;
    vendorDef: any;
    rowSelectionSingle: string;
    searchValue: any;
    d: any;
    defaultColDefVen: any;
    selectedVendorInfo: any;
    public hotkeyList: Hotkey[];
    // filterType:any;
    unitInfo: any;
    Outstanding_Amount: any;

    constructor(public utilityService: UtilityService, private hotkeysService: HotkeysService, private http: HttpClient, private modalService: NgbModal) {
        this.hotkeysService = hotkeysService;
        this.http = http;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        $(document).ready(function () {
            var position = $('#popup-vendor-list').offset();
            var body = $('body').height();
            var foot = $('.info_detail_grey_block').height();
            var appHeight = body - position.top - foot - 40 + 'px !important';
            $('#popup-vendor-list').attr('style', 'height:' + appHeight);
        });
    }

    ngOnInit(): void {
        //   console.log('product template init!');
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.paginationConf = true;
        this.initHotkeys();
        this.filterType = 'SearchVendor';
        this.vendorList = [];
        this.overlayLoadingTemplate = "<div class='loader2'>" +
            "<div class='loading'><img src='public/loader-icon-2.svg'></div>" +
            "</div>";
        setTimeout(() => {
            $('#filter-text-box').focus();
        }, 100);
    }

    onGridReadyVen(params) {

        var parent = this;
        $("#filter-text-box").keypress(function (event) {
            if (event.keyCode == 13) {
                parent.onVendSelectionChanged(parent);
            }
        });

        if (!this.filterType) {
            this.filterType = "SearchVendor";
        }
        $(document).ready(function () {
            if (parent.filterType == 'Vendor_Code') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Vendor By Code (Ctrl+f)").blur();
            } else if (parent.filterType == 'SearchVendor') {
                $("input[id=filter-text-box]").attr("placeholder", "Search Vendor By Name (Ctrl+f)").blur();
            }
            setTimeout(() => {
                $('#filter-text-box').focus();
            }, 200);
            $(".radio-label").change(function () {
                var select = $(this).val();
                $("input#filter-text-box").val("");
                parent.gridApiVen.setFilterModel(null);
                parent.gridApiVen.onFilterChanged();
                if (select == 'Vendor_Code') {
                    $("input[id=filter-text-box]").attr("placeholder", "Search Vendor By Code (Ctrl+f)").blur();
                } else if (select == 'SearchVendor') {
                    $("input[id=filter-text-box]").attr("placeholder", "Search Vendor By Name (Ctrl+f)").blur();
                }
                setTimeout(() => {
                    $('#filter-text-box').focus();
                }, 200);
            });
        });


        this.vendorDef = [
            { headerName: 'Code', field: 'Vendor_Code', width: 97 },
            { headerName: 'Vendor Name', field: 'Vendor_Name', width: 168 },
            { headerName: 'SearchVendor', field: 'SearchVendor', hide: true },
            { headerName: 'Address', field: 'Vendor_Address1', width: 194 },
            { headerName: 'City', field: 'City_Desc', width: 120 },
            { headerName: 'State', field: 'State_Desc', width: 150 },
            { headerName: 'Mobile No', field: 'Vendor_Mobile', width: 109 },
            { headerName: 'Email ID', field: 'Vendor_EmailID', width: 236 },
            { headerName: 'Alt Code', field: 'altCode', width: 65 },
        ];

        this.vendorList = this.vendorList1;
        this.gridApiVen = params.api;
        this.gridColumnApiCust = params.columnApi;

        setTimeout(() => {

            this.gridColumnApiCust = params.columnApi;
            this.gridApiVen.sizeColumnsToFit();
            this.sortVentNameAsc();
            var index = 0;
            // console.log('this.SerachValue : ',this.SerachValue);
            if (this.LastSelectedId) {
                // index = this.vendorList1.map(item => item.Vendor_ID).indexOf(this.LastSelectedId);
                index = this.gridApiVen.getModel().rowsToDisplay.map(item => item.data.Vendor_ID).indexOf(this.LastSelectedId);
                // if (this.gridApiVen.getInfiniteRowCount() < index) {
                //     this.gridApiVen.setInfiniteRowCount(index, false);
                // }
                if (index >= 0) {
                    this.gridApiVen.ensureIndexVisible(index);
                }
                // this.gridApiCust.setFocusedCell(index, "Customer_LegalName");
                setTimeout(() => {
                    var RowCount = this.gridApiVen.getModel().getRowCount();
                    if (RowCount >= index && RowCount > 0) {
                        this.SelectedRowIndex = index;
                        this.gridApiVen.getModel().getRow(index).setSelected(true);
                    }
                    // this.gridApiPrd.setFocusedCell(index, "Product_Code");
                }, 200);
            }
            $('#filter-text-box').focus().select();
            if (this.SerachValue) {
                this.SelectedRowIndex = index;
                this.searchValue = this.SerachValue;
                this.quickSearch("", "vendor");
            } else {
                var rowCount = this.gridApiVen.getModel().getRowCount();
                if (rowCount >= index && rowCount > 0) {
                    this.selectedVendorInfo = this.gridApiVen.getModel().getRow(index).setSelected(true);
                } else if (rowCount > 0) {
                    this.selectedVendorInfo = this.gridApiVen.getModel().getRow(0).setSelected(true);
                }
            }

        }, 100);
        // if(this.vendorList1.length > 0){
        //     setTimeout( () => {
        //         this.selectedVendorInfo = this.gridApiVen.getModel().getRow(0).setSelected(true);
        //       //   console.log(this.selectedVendorInfo);
        //     }, 100);
        // }

        this.defaultColDefVen = {
            resizable: true,
            sortable: true,
        };
    }

    initHotkeys() {
        this.hotkeyList = [];
        const altd = new Hotkey('alt+d', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="Vendor_Code"]').trigger('click');
            //this.OnVendorButtonChange();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altd);
        this.hotkeysService.add(altd);

        const altn = new Hotkey('alt+n', (event: KeyboardEvent): boolean => {
            $('.master-header label[name="SearchVendor"]').trigger('click');
            //this.OnVendorButtonChange();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altn);
        this.hotkeysService.add(altn);

        const altc = new Hotkey('home', (event: KeyboardEvent): boolean => {
            this.clearAllFilter();
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altc);
        this.hotkeysService.add(altc);

        const altB = new Hotkey('alt+b', (event: KeyboardEvent): boolean => {
            this.outstandingClick();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(altB);
        this.hotkeysService.add(altB);

        const ctrlf = new Hotkey('ctrl+f', (event: KeyboardEvent): boolean => {

            var textbox: any;
            textbox = document.querySelector('#filter-text-box');
            if (textbox) {
                const bound = textbox.getBoundingClientRect();
                if (bound && bound.top) {
                    $('#filter-text-box').focus();
                }
            }
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrlf);
        this.hotkeysService.add(ctrlf);
    }

    ngOnDestroy() {
        this.hotkeysService.remove(this.hotkeyList);
    }

    OnVendorButtonChange() {
        this.searchValue = "";
        if (this.filterType == "Vendor_Code") {
            $("input[id=filter-text-box]").attr("placeholder", "Search Vendor By Code (Ctrl+f)").blur();
        } else {
            $("input[id=filter-text-box]").attr("placeholder", "Search Vendor By Name (Ctrl+f)").blur();
        }
        $('.master-header #filter-text-box').focus();
        this.quickSearch('', 'vendor');
    }

    gridEventDown(event) {
        if (event.keyCode == 13) {
            //   console.log("keydown", event);
            this.onVendSelectionChanged(this);
        } else if (event.keyCode == 8) {
            setTimeout(() => {
                $('#filter-text-box').focus().select();
            }, 200);
        } else if (event.keyCode >= 65 && event.keyCode <= 90) {
            // $('#filter-text-box').focus().select();
            $('#filter-text-box').focus();
            this.searchValue = event.key;
            this.quickSearch('', 'vendor');
        }

    }

    private venSelectionMain(self: this) {
        let selectedRows = self.gridApiVen.getSelectedRows();
        let vend = selectedRows[0];
        if (this.DisableClose == 1) {
            return false;
        }
        //   console.log("selected cust:", selectedRows[0]);
        if (vend != undefined) {
            //   console.log('selected ccustomer:', vend);
            this.SelectedVendor.emit(vend);
        }
    }

    invoiceInfo: any;
    Vendor_Name: any;
    Vendor_ID: any;
    Vendor_LegalName: any;
    Vendor_Address1: any;
    Vendor_Full_Address: any
    Vendor_Phone: any;
    Vendor_Mobile: any;
    Vendor_EmailID: any;
    CreditLimit: any;
    CreditDays: any;
    PayTerm_Desc: any;
    Vendor_GSTNo: any;
    httpCalling: any;
    Vendor_Status: any;
    Vendor_StatusReason: any;
    venSelected(event) {

        let selectedRowVen = this.gridApiVen.getSelectedRows();
        var SelectedRowIndex = [];
        SelectedRowIndex = this.gridApiVen.getSelectedNodes();
        var index = 0;
        if (SelectedRowIndex.length > 0) {
            index = this.vendorList.map(item => item.Vendor_ID).indexOf(SelectedRowIndex[0].data.Vendor_ID);
            this.SelectedRowIndex = Number(this.gridApiVen.getRowNode(index).rowIndex);
        } else {
            this.SelectedRowIndex = 0;
        }
        // 
        this.selectedVendorInfo = selectedRowVen[0];
        this.selectedVendorInfo.LastInvoiceDays = 0;
        this.SetProductDetails(this.selectedVendorInfo);
        //   console.log(this.selectedVendorInfo);
        this.GetVendorOutstanding(this.selectedVendorInfo.Vendor_ID);
        //this.todayD = moment(this.poapproval.Doc_Date).format(this.dateFormat.dateInputFormat);
        // if (this.selectedVendorInfo.Invoice_Details){
        //     this.invoiceInfo = JSON.parse(this.selectedVendorInfo.Invoice_Details);
        //     if(this.invoiceInfo.length > 0 && this.invoiceInfo[0].Invoice_Date != null && this.invoiceInfo[0].Invoice_Date != ""){
        //         let invoice = this.invoiceInfo.sort((val1, val2) => {return <any>(new Date(val2.Invoice_Date)) - <any>(new Date(val1.Invoice_Date))});
        //         var diff = Math.abs(new Date().getTime() - new Date(invoice[0].Invoice_Date).getTime());
        //         this.selectedVendorInfo.LastInvoiceDays = Math.floor(diff / (1000 * 3600 * 24));
        //     }
        // }
    }

    GetVendorOutstanding(Vendor_ID) {
        let data = {
            "Vendor_ID": Vendor_ID,
            "Company_ID": this.unitInfo.Company_ID,
            "Unit_ID": this.unitInfo.Unit_ID,
        };
        if (this.httpCalling && this.httpCalling.isStopped == false) {
            this.httpCalling.unsubscribe();
        }
        this.httpCalling = this.http.post('/api/vendors/GetVendorOutstanding', data)
            .subscribe((response: any) => {
                this.Outstanding_Amount = 0;
                if (response.length > 0) {
                    this.Outstanding_Amount = response[0]["Outstanding_Amt"];
                }
            });
    }

    SetProductDetails(selectedVendorInfo) {
        this.Vendor_Name = selectedVendorInfo.Vendor_Name;
        this.Vendor_ID = selectedVendorInfo.Vendor_ID;
        this.Vendor_LegalName = selectedVendorInfo.Vendor_LegalName;
        this.Vendor_Address1 = selectedVendorInfo.Vendor_Address1;
        this.Vendor_Mobile = selectedVendorInfo.Vendor_Mobile;
        this.Vendor_EmailID = selectedVendorInfo.Vendor_EmailID;
        this.CreditLimit = selectedVendorInfo.CreditLimit;
        this.CreditDays = selectedVendorInfo.CreditDays;
        this.PayTerm_Desc = selectedVendorInfo.PayTerm_Desc;
        this.Vendor_Full_Address = selectedVendorInfo.Vendor_Full_Address;
        this.Vendor_Phone = selectedVendorInfo.Vendor_Phone;
        this.Vendor_GSTNo = selectedVendorInfo.Vendor_GSTNo;
        this.Vendor_Status = selectedVendorInfo.Vendor_Status;
        this.Vendor_StatusReason = selectedVendorInfo.Vendor_StatusReason;
        this.Outstanding_Amount = 0;
    }

    onVendSelectionChanged(event) {
        var RowCount = this.gridApiVen.getModel().getRowCount();
        if (RowCount == 0) {
            return false;
        }
        let selectedRows = this.gridApiVen.getSelectedRows();
        let vend = selectedRows[0];
        if (this.DisableClose == 1) {
            return false;
        }
        //   console.log("selected vend:", selectedRows[0]);
        if (vend != undefined) {
            if (this.httpCalling.isStopped) {
                vend.Outstanding_Amount = this.Outstanding_Amount;
                //   console.log('selected Vendor:', vend);
                this.SelectedVendor.emit(vend);
            } else {
                this.httpCalling ? this.httpCalling.unsubscribe() : null;
                let data = {
                    "Vendor_ID": vend.Vendor_ID,
                    "Company_ID": this.unitInfo.Company_ID,
                    "Unit_ID": this.unitInfo.Unit_ID,
                };
                this.http.post('/api/vendors/GetVendorOutstanding', data)
                    .subscribe((response: any) => {
                        this.Outstanding_Amount = 0;
                        if (response.length > 0) {
                            this.Outstanding_Amount = response[0]["Outstanding_Amt"];
                            vend.Outstanding_Amount = this.Outstanding_Amount;
                        }
                        this.SelectedVendor.emit(vend);
                    });
            }
        }
    }

    quickSearch(event, id, OnLoad = 0) {
        if (event.which == 37 || event.which == 38 || event.which == 39 || event.which == 16 || event.which == 17 || event.which == 70) {
            return false;
        }
        if(event.which == 27) {
            this.d();
            return false;
        }
        if (event.which == 40) {
            var RowCount = this.gridApiVen.getModel().getRowCount();
            if (RowCount >= this.SelectedRowIndex && RowCount > 0) {
                this.gridApiVen.ensureIndexVisible(this.SelectedRowIndex);
                this.gridApiVen.getModel().getRow(this.SelectedRowIndex).setSelected(true);
                this.gridApiVen.setFocusedCell(this.SelectedRowIndex, "Vendor_Code");
            }
            return false;
        } else {
            this.SelectedRowIndex = 0;
        }
        var IsSearchContain = "";
        if (id == 'vendor') {
            var sportsFilterComponent = this.gridApiVen.getFilterInstance(this.filterType);
            if (this.searchValue) {
                // let search:any;
                // if(this.filterType == 'SearchVendor'){
                let search = (this.searchValue ? this.searchValue.toString() : "").trim();
                let search1 = search.split(" ");
                if (search1.length > 1) {
                    sportsFilterComponent.setModel({
                        condition2: {
                            type: "contains",
                            filter: search1[1]
                        },
                        condition1: {
                            type: "startsWith",
                            filter: search1[0]
                        },
                        condition3: {
                            type: "contains",
                            filter: search1[1]
                        },
                        operator: "AND"
                    });
                } else {
                    var index = search.indexOf("%");
                    if (index >= 0) {
                        search = search.replace(/%/g, "");
                        IsSearchContain = search;
                        //   console.log(" search: ", search);
                    }
                    sportsFilterComponent.setModel({
                        //type: (index >= 0)? "contains": "startsWith",
                        type: (index >= 0) ? "contains" : "contains",
                        filter: search
                    });
                    if (index < 0) {
                        this.gridApiVen.onFilterChanged();
                        if (this.gridApiVen.getModel().getRowCount() == 0) {
                            sportsFilterComponent.setModel({
                                type: "contains",
                                filter: search
                            });
                        }
                    }
                }
                // } else {
                //     search = (this.searchValue? this.searchValue.toString(): "").trim().split(" ");
                //     sportsFilterComponent.setModel({
                //         condition2: {
                //             type: "contains",
                //             filter: search[1]
                //         },
                //         condition1: {
                //             type: "startsWith",
                //             filter: search[0]
                //         },
                //         condition3: {
                //             type: "startsWith",
                //             filter: search[1]
                //         },
                //         operator: "AND"
                //     });
                // }
            } else {
                this.gridApiVen.setFilterModel(null);
            }

            this.gridApiVen.onFilterChanged();
            var TotalRowCount = this.gridApiVen.getModel().getRowCount();
            if (TotalRowCount > 0 && OnLoad == 0) {
                if ((IsSearchContain ? IsSearchContain : "").length > 0) {
                    IsSearchContain = IsSearchContain.toUpperCase();
                    // var inde = this.vendorList.filter(function(it){return it.SearchVendor.startsWith(IsSearchContain)});
                    var inde = this.gridApiVen.getModel().rowsToDisplay.filter(item => item.data.SearchVendor == IsSearchContain);
                    if (inde.length > 0) {
                        this.SelectedRowIndex = this.gridApiVen.getModel().rowsToDisplay.map(item => item.data.Vendor_ID).indexOf(inde[0].data.Vendor_ID);
                        // this.SelectedRowIndex = Number(this.gridApiVen.getRowNode(index).rowIndex);
                        // if (this.gridApiVen.getInfiniteRowCount() < this.SelectedRowIndex) {
                        //     this.gridApiVen.setInfiniteRowCount(this.SelectedRowIndex, false);
                        // }
                        var RowCount = this.gridApiVen.getModel().getRowCount();
                        if (RowCount > 0) {
                            this.gridApiVen.ensureIndexVisible(this.SelectedRowIndex);
                        }
                    } else {
                        this.SelectedRowIndex = 0;
                    }
                } else {
                    // if (this.gridApiVen.getInfiniteRowCount() < this.SelectedRowIndex) {
                    //     this.gridApiVen.setInfiniteRowCount(this.SelectedRowIndex, false);
                    // }
                    this.gridApiVen.ensureIndexVisible(this.SelectedRowIndex);
                }
                if (this.SelectedRowIndex >= TotalRowCount) {
                    this.SelectedRowIndex = 0;
                }
                var RowCount = this.gridApiVen.getModel().getRowCount();
                if (RowCount >= this.SelectedRowIndex && RowCount > 0) {
                    this.gridApiVen.getModel().getRow(this.SelectedRowIndex).setSelected(true);
                }
            } else {
                this.SelectedRowIndex = 0;
                var RowCount = this.gridApiVen.getModel().getRowCount();
                if (RowCount >= this.SelectedRowIndex && RowCount > 0) {
                    this.gridApiVen.getModel().getRow(this.SelectedRowIndex).setSelected(true);
                }
            }
            var RowCount = this.gridApiVen.getModel().getRowCount();
            if ((event.which == 13 || event.which == 40) && RowCount >= this.SelectedRowIndex && RowCount > 0) {
                this.gridApiVen.setFocusedCell(this.SelectedRowIndex, "Vendor_Code");
            }

        }
    }
    // quickSearch(event, id , ) {
    //      if (id == 'vendor') {
    //         this.gridApiVen.setFilterModel(null);
    //         var sportsFilterComponent = this.gridApiVen.getFilterInstance(this.filterType);
    //         if(this.searchValue){
    //             let search = this.searchValue.split(' ');
    //             sportsFilterComponent.setModel({
    //                 condition2: {
    //                     type: "contains",
    //                     filter: search[1]
    //                 },
    //                 condition1: {
    //                     type: "startsWith",
    //                     filter: search[0]
    //                 },
    //                 operator: "AND"
    //             });
    //         }
    //         this.gridApiVen.onFilterChanged();
    //         if (Number(this.gridApiVen.getModel().getRowCount()) > 0) {
    //             this.gridApiVen.getModel().getRow(0).setSelected(true);
    //             if (event.which == 13 || event.which == 40) {
    //                 this.gridApiVen.setFocusedCell(0, "Vendor_Code");
    //             }
    //         }    
    //     }
    // }

    clearAllFilter() {
        this.searchValue = '';
    }

    modalReference: NgbModalRef;
    outstandingClick() {
        this.modalReference = this.modalService.open(this.vendoroutstanding, { size: 'sm', windowClass: 'data-show ledger-modal-popup' });
        var self = this;
        this.modalReference.result.then(() => {
            self.modalReference = undefined;
            self.removeHotKeyServices();
        }, () => {
            self.modalReference = undefined;
            self.removeHotKeyServices();
        });
    }

    removeHotKeyServices() {
        this.hotkeysService.remove(this.hotkeyList);
        this.hotkeysService.add(this.hotkeyList);
    }

    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if (Num) {
            return Num;
        }
        return 0;
    }

    sortCodeAsc() {
        const sortModel = [
            { colId: 'Vendor_Code', sort: 'asc' }
        ];
        this.gridApiVen.setSortModel([]);
        this.gridApiVen.setSortModel(sortModel);
    }

    sortVentNameAsc() {
        const sortModel = [
            { colId: 'Vendor_Name', sort: 'asc' }
        ];
        this.gridApiVen.setSortModel([]);
        this.gridApiVen.setSortModel(sortModel);
    }

}